import React, { Component, ErrorInfo, ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

const ErrorContainer = styled.div`
  padding: 40px;
  margin: 40px auto;
  max-width: 800px;
  background-color: ${({ theme }) => theme.errorBackground};
  border: 1px solid ${({ theme }) => theme.error};
  border-radius: 12px;
  color: ${({ theme }) => theme.error};
  font-family: monospace;
`;

const Pre = styled.pre`
  background: ${({ theme }) => theme.card};
  padding: 16px;
  border-radius: 8px;
  overflow-x: auto;
  font-size: 12px;
  margin-top: 16px;
  border: 1px solid ${({ theme }) => theme.error};
`;

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <ErrorContainer>
          <h2>Ocorreu um erro inesperado de interface.</h2>
          <p>A aplicação encontrou um problema ao renderizar este componente. Por favor, avise o suporte com os detalhes abaixo:</p>
          <Pre>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo?.componentStack}
          </Pre>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}
